export const BRANCH = "branchName"    
export const TENANT = "tenantId"
export const DEFAULT_LANGUAGE = "defaultLanguage"
